export default `
  mutation($id: String!) {
    deleteLiveSearchReport(id: $id) {
      id
    }
  }
`;